import { ColDef } from '@ag-grid-community/core';

export const columnDefs: ColDef[] = [
    {
        field: 'asset',
        headerName: 'Asset',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
        flex: 1
    },
    {
        field: 'currentBalance',
        headerName: 'Current Balance',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
        flex: 1
    },
    {
        field: 'equivalentValue',
        headerName: 'Equivalent Value',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
        flex: 1
    },
    {
        field: 'assetPrice',
        headerName: 'Asset Price',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
        flex: 1
    }
];